import script from "./AddAggregateBusinessGroupModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddAggregateBusinessGroupModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddAggregateBusinessGroupModal.vue?vue&type=style&index=0&id=9366cd3e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9366cd3e"]])

export default __exports__